/**
 * Lazy loader for the generated CodeStitch class autocomplete index.
 *
 * Production path: routes through asset-loader.loadJSON for R2 + manifest support.
 * Test path: __setCsClassIndexFetchForTests installs a Response-returning mock
 * that simulates the legacy fetch shape; this bypasses asset-loader entirely.
 */

import { loadJSON } from '../core/asset-loader.js';

let _classIndexPromise = null;
let _fetchFn = null;

function transform(data) {
  return {
    classes: Array.isArray(data?.classes) ? data.classes : [],
    sourceHash: typeof data?.sourceHash === 'string' ? data.sourceHash : '',
    sourceCount: Number.isFinite(data?.sourceCount) ? data.sourceCount : 0
  };
}

export function loadCsClassIndex() {
  if (!_classIndexPromise) {
    _classIndexPromise = (async () => {
      try {
        let data;
        if (_fetchFn) {
          // Test-injection path: use Response-returning mock
          const res = await _fetchFn();
          if (!res?.ok) throw new Error(`HTTP ${res?.status || 'unknown'}`);
          data = await res.json();
        } else {
          // Production path: route through asset-loader (R2 + manifest)
          data = await loadJSON('data/cs-class-index.json');
        }
        return transform(data);
      } catch (err) {
        console.warn('[CodeView] Could not load CodeStitch class index:', err?.message || err);
        return { classes: [] };
      }
    })();
  }
  return _classIndexPromise;
}

export function __setCsClassIndexFetchForTests(fn) {
  _fetchFn = typeof fn === 'function' ? fn : _fetchFn;
  _classIndexPromise = null;
}

export function __resetCsClassIndexLoaderForTests() {
  _fetchFn = null;
  _classIndexPromise = null;
}
